import type { IHardcodedTag, TClusterStatus } from '~/types/cluster'

import appListLogo from '~/assets/cluster-status-icon--app-list.png'
import bdDoneLogo from '~/assets/cluster-status-icon--bd-done.png'
import completeLogo from '~/assets/cluster-status-icon--complete.png'
import finishLogo from '~/assets/cluster-status-icon--finish.png'
import todoLogo from '~/assets/cluster-status-icon--todo.png'
import topPmLogo from '~/assets/cluster-status-icon--top-pm.png'

export const CLUSTER_STATUSES: { color: string; icon: string; label: string; value: TClusterStatus }[] = [
  { color: '#00000080', icon: todoLogo, label: 'Todo', value: 'todo' },
  { color: '#FBC62F', icon: appListLogo, label: 'Cluster Completed', value: 'cluster_completed' },
  { color: '#FB912F', icon: topPmLogo, label: 'Create Top Leaders Analyze', value: 'create_top_leaders_analyze' },
  { color: '#13A4F6', icon: bdDoneLogo, label: 'PM Apps Testing', value: 'pm_apps_testing' },
  { color: '#00C064', icon: completeLogo, label: 'BD Contact', value: 'bd_contact' },
  { color: '#FF5301', icon: finishLogo, label: 'App Signed', value: 'app_signed' },
]

export const APPLICATION_HARDCODED_TAGS: IHardcodedTag[] = [
  { icon: '🚫', label: 'Blacklisted', value: 'blacklisted' },
  { icon: '🛟', label: 'Rescued', value: 'rescued' },
  { icon: '⭐', label: 'Star', value: 'star' },
  { icon: '👀', label: 'To Contact', value: 'to_contact' },
]

export const CLUSTER_HARDCODED_TAGS: IHardcodedTag[] = [
  { icon: '🔥', label: 'MVP', value: 'mvp' },
  { icon: '⭐', label: 'Publishing', value: 'publishing' },
]

export const getBadgeLabel = (value: string, hardcodedTags: IHardcodedTag[]): string => {
  const match = hardcodedTags.find((el) => el.value === value)

  return match ? `${match.icon} ${match.label}` : value
}

export const FEATURE_SELECT_VALUES = [
  { key: '', score: 0 },
  { key: '0%', score: 0 },
  { key: '10%', score: 10 },
  { key: '20%', score: 20 },
  { key: '30%', score: 30 },
  { key: '40%', score: 40 },
  { key: '50%', score: 50 },
  { key: '60%', score: 60 },
  { key: '70%', score: 70 },
  { key: '80%', score: 80 },
  { key: '90%', score: 90 },
  { key: '100%', score: 100 },
]
